// extracted by mini-css-extract-plugin
export default {"scroller":"OverlayScroller-scroller-Qv2oP","track":"OverlayScroller-track-NpAah","thumb":"OverlayScroller-thumb-IKMmD"};